// extracted by mini-css-extract-plugin
export default {"form":"add-contact_form__ymNCf","label":"add-contact_label__CnNze","input":"add-contact_input__5WLbP","button":"add-contact_button__WsWmS"};